import React, { useEffect, useRef, useState } from "react";
import { Form, Spin, Tree } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import GenerateModal from "./GenerateModal";
import { fetchReportTree } from "../../features/fetch/fetchSlice";
import BreadCrumb from "../../layout/BreadCrumb";
import GenerateDynamicModal from "./GenerateDynamicModal";

function MainReports() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const { user } = useSelector((state) => state.auth);
  const [prodd, setProdd] = useState("");

  const [open, setopen] = useState(false);

  async function handleCancel() {
    await setopen(false);
    await setCheckedKeys([]);
  }

  const [proddDynamic, setProddDynamic] = useState("");

  const [openDynamic, setopenDynamic] = useState(false);

  async function handleCancelDynamic() {
    await setopenDynamic(false);
    await setCheckedKeys([]);
  }

  const { loading, reportTree } = useSelector((state) => state.fetch);
  const dispatch = useDispatch();
  const [treeData, setTreeData] = useState([
    {
      title: "NISIP_REPORTS",
      key: "pcategory_1",
      isLeaf: false,
      disableCheckbox: true,
      cls: "folder",
    },
  ]);

  const [treeDataDynamic, setTreeDataDynamic] = useState([
    {
      title: "NISIP_DYNAMIC_REPORTS",
      key: "pcategory_dynamic",
      isLeaf: false,
      cls: "folder",
      disableCheckbox: true,
    },
  ]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);

  const fetchChildren = async (key) => {
    try {
      const res = await dispatch(
        fetchReportTree({
          url: "api/v1/reports/fetch-report-tree",
          node: key,
        })
      );
      if (res?.payload?.success) {
        const checkedKeysFromResponse = res?.payload?.data?.result
          .filter((item) => item?.checked)
          .map((item) => item?.id);
        setCheckedKeys(checkedKeysFromResponse);

        return res?.payload?.data?.result?.map((item) => ({
          title: item?.text,
          key: item?.id,
          isLeaf: item?.cls === "file",
          disableCheckbox: item?.cls === "folder",
          cls: item?.cls,
        }));
      }
      return [];
    } catch (error) {
      console.error("Error fetching children: ", error);
      return [];
    }
  };

  const onExpand = async (expandedKeys, { expanded, node }) => {
    if (expanded) {
      setExpandedKeys(expandedKeys);
      if (
        expandedKeys?.includes("applications") &&
        expandedKeys?.includes("0")
      ) {
        setExpandedKeys((prevKeys) => {
          return ["applications", "0", node.key];
        });
      } else if (
        expandedKeys?.includes("reports") &&
        expandedKeys?.includes("0")
      ) {
        setExpandedKeys((prevKeys) => {
          return ["reports", "0", node.key];
        });
      }

      const children = await fetchChildren(node?.key);
      setTreeData((prevTreeData) =>
        updateTreeData(prevTreeData, node?.key, children)
      );
    } else {
      setExpandedKeys(expandedKeys);
    }
  };

  const updateTreeData = (list, key, children) => {
    return list.map((node) => {
      if (node?.key === key) {
        return { ...node, children };
      }
      if (node?.children) {
        return {
          ...node,
          children: updateTreeData(node?.children, key, children),
        };
      }
      return node;
    });
  };

  const onCheck = async (checkedKeysValue, { checked, node }) => {
    if (node?.cls === "folder") {
      return;
    }
    const singleCheckedKey = checked ? [node?.key] : [];
    await setCheckedKeys(singleCheckedKey);
    await setProdd(node);
    await setopen(checked);
  };

  const onSelect = async (selectedKeys, { selected, node }) => {
    if (node?.cls === "folder") {
      return;
    }
    const singleCheckedKey = selected ? [node?.key] : [];
    await setCheckedKeys(singleCheckedKey);
    await setProdd(node);
    await setopen(selected);
  };

  const fetchChildrenDynamic = async (key) => {
    try {
      const res = await dispatch(
        fetchReportTree({
          url: "api/v1/reports/getDynamicReportList",
          node: key,
        })
      );
      if (res?.payload?.success) {
        const checkedKeysFromResponse = res?.payload?.data?.result
          .filter((item) => item?.checked)
          .map((item) => item?.id);
        setCheckedKeys(checkedKeysFromResponse);

        return res?.payload?.data?.result?.map((item) => ({
          title: item?.view_name,
          key: item?.id,
          isLeaf: item?.cls === "file",
          disableCheckbox: item?.cls === "folder",
          cls: item?.cls,
        }));
      }
      return [];
    } catch (error) {
      console.error("Error fetching children: ", error);
      return [];
    }
  };
  const onExpandDynamic = async (expandedKeys, { expanded, node }) => {
    if (expanded) {
      setExpandedKeys(expandedKeys);

      const children = await fetchChildrenDynamic(node?.key);
      setTreeDataDynamic((prevTreeData) =>
        updateTreeDataDynamic(prevTreeData, node?.key, children)
      );
    } else {
      setExpandedKeys(expandedKeys);
    }
  };
  const updateTreeDataDynamic = (list, key, children) => {
    return list.map((node) => {
      if (node?.key === key) {
        return { ...node, children };
      }
      if (node?.children) {
        return {
          ...node,
          children: updateTreeDataDynamic(node?.children, key, children),
        };
      }
      return node;
    });
  };

  const onCheckDynamic = async (checkedKeysValue, { checked, node }) => {
    if (node?.cls === "folder") {
      return;
    }
    const singleCheckedKey = checked ? [node?.key] : [];
    await setCheckedKeys(singleCheckedKey);
    await setProddDynamic(node);
    await setopenDynamic(checked);
  };

  const onSelectDynamic = async (selectedKeys, { selected, node }) => {
    if (node?.cls === "folder") {
      return;
    }
    const singleCheckedKey = selected ? [node?.key] : [];
    await setCheckedKeys(singleCheckedKey);
    await setProddDynamic(node);
    await setopenDynamic(selected);
  };

  return (
    <>
      <BreadCrumb breadcrumbs={[{ title: "Reports" }]} />
      <div className="white_card mt-[1.25rem] flex-1  min-h-[80vh]">
        <Spin spinning={loading}>
          <Tree
            checkable
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            checkedKeys={checkedKeys}
            onCheck={onCheck}
            onSelect={onSelect}
            treeData={treeData}
          />
        </Spin>
        <Spin spinning={loading}> 
          <Tree
            checkable
            onExpand={onExpandDynamic}
            expandedKeys={expandedKeys}
            checkedKeys={checkedKeys}
            onCheck={onCheckDynamic}
            onSelect={onSelectDynamic}
            treeData={treeDataDynamic}
          />
        </Spin>
      </div>

      <GenerateModal open={open} handleCancel={handleCancel} prodd={prodd} />
      <GenerateDynamicModal
        open={openDynamic}
        handleCancel={handleCancelDynamic}
        prodd={proddDynamic}
      />
    </>
  );
}

export default MainReports;
